import React from 'react';

const AboutSection: React.FC = () => {
  const stats = [
    { number: '50+', label: 'Projects Delivered' },
    { number: '25+', label: 'Happy Clients' },
    { number: '5+', label: 'Years Experience' },
    { number: '14', label: 'Days Average MVP' }
  ];

  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation First',
      description: 'We leverage cutting-edge technologies to solve complex business challenges'
    },
    {
      icon: 'ri-team-line',
      title: 'Expert Team',
      description: 'Our skilled professionals bring years of experience in software consulting'
    },
    {
      icon: 'ri-time-line',
      title: 'Rapid Delivery',
      description: 'Fast turnaround times without compromising on quality or functionality'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Reliable Solutions',
      description: 'Production-ready, scalable solutions built with industry best practices'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
                About Antriva
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Antriva is a leading software consulting company that specializes in delivering 
                innovative technology solutions. We help businesses transform their operations 
                through custom software development, digital transformation strategies, and 
                cutting-edge technology implementations.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our expert team provides comprehensive consulting services to drive growth and 
                efficiency for companies across various industries, from startups to enterprise-level 
                organizations.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-teal-600 mb-2">
                    {stat.number}
                  </div>
                  <div className="text-sm text-gray-600 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Content - Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20software%20development%20team%20working%20collaboratively%20in%20a%20modern%20office%20environment%20with%20multiple%20monitors%2C%20clean%20workspace%2C%20natural%20lighting%2C%20and%20contemporary%20design%20elements%20showcasing%20teamwork%20and%20innovation%20in%20technology%20consulting&width=600&height=400&seq=about-team-001&orientation=landscape"
                alt="Antriva Team"
                className="w-full h-96 object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="mt-20">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Why Choose Antriva
            </h3>
            <p className="text-lg text-gray-600">
              Our core values drive everything we do
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div key={index} className="text-center group">
                <div className="w-16 h-16 rounded-full bg-teal-100 flex items-center justify-center text-teal-600 mb-4 mx-auto group-hover:bg-teal-500 group-hover:text-white transition-all duration-300">
                  <i className={`${value.icon} text-2xl`}></i>
                </div>
                <h4 className="text-xl font-semibold text-gray-900 mb-3">
                  {value.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;